import { createTheme } from "@mui/material/styles";

// MUI theme wired to the autumn tokens (see docs/DESIGN.md). Soft radii, soft
// shadows, generous touch targets (≥44px), restrained palette.
export const theme = createTheme({
  palette: {
    // Autumn-led: terracotta/clay primary, amber-gold accent, warm sand surfaces.
    primary: { main: "#C8381E", dark: "#A82C16", light: "#E67A5C", contrastText: "#ffffff" },
    secondary: { main: "#C2891F", dark: "#7A5512", light: "#E0B85C", contrastText: "#ffffff" },
    error: { main: "#8C1E2B" },
    warning: { main: "#C9941E" },
    success: { main: "#3E7D4E" }, // forest green kept for positive/success accents
    info: { main: "#3B6E83" },
    background: { default: "#FAF3E9", paper: "#ffffff" }, // warm sand
    text: { primary: "#2A231C", secondary: "#6E6253" },
    divider: "#E7D9C5",
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: "'Inter', -apple-system, system-ui, sans-serif",
    h1: { fontFamily: "'Fraunces', Georgia, serif", fontWeight: 500, letterSpacing: "-0.02em", lineHeight: 1.1 },
    h2: { fontFamily: "'Fraunces', Georgia, serif", fontWeight: 500, letterSpacing: "-0.01em", lineHeight: 1.15 },
    h3: { fontFamily: "'Fraunces', Georgia, serif", fontWeight: 500, lineHeight: 1.2 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        // Slank als standaard (2026-07, feedback "onze dikke knop is meestal
        // te dik"): medium = gewone actieknop, small = inline-actie. Alleen
        // size="large" behoudt het volle hero-CTA-formaat (funnel/auth).
        root: { borderRadius: 9999, padding: "8px 20px", minHeight: 40, fontSize: ".95rem" },
        sizeSmall: { padding: "4px 14px", minHeight: 32, fontSize: ".85rem" },
        sizeLarge: { padding: "16px 32px", minHeight: 56, fontSize: "1.0625rem" },
      },
    },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 16 } } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 10 } } },
  },
});
